// extracted by mini-css-extract-plugin
export default {"LoginCard":"LoginCard--POAQv","success":"success--UAbvh","listWrapper":"listWrapper--qcrBf","list":"list--cbPwf","connect":"connect--UP0CM","imageWrapper":"imageWrapper--aTX96"};